import React from "react";

const TwitterBrand1 = ({ width = 32, height = 32 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3329_131768)">
      <path
        d="M16 0C7.16375 0 0 7.16375 0 16C0 24.8363 7.16375 32 16 32C24.8363 32 32 24.8363 32 16C32 7.16375 24.8363 0 16 0Z"
        fill="black"
      />
      <path
        d="M17.7506 14.5521L24.6 6.59021H22.9769L17.0296 13.5034L12.2795 6.59021H6.80078L13.9839 17.0442L6.80078 25.3934H8.42397L14.7045 18.0929L19.721 25.3934H25.1997L17.7502 14.5521H17.7506ZM9.00881 7.81213H11.5019L22.9777 24.2271H20.4846L9.00881 7.81213Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3329_131768">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default TwitterBrand1;
